import { render, staticRenderFns } from "./AutomaticUploadsForm.vue?vue&type=template&id=47b00aba&scoped=true&"
import script from "./AutomaticUploadsForm.vue?vue&type=script&lang=js&"
export * from "./AutomaticUploadsForm.vue?vue&type=script&lang=js&"
import style0 from "./AutomaticUploadsForm.vue?vue&type=style&index=0&id=47b00aba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b00aba",
  null
  
)

export default component.exports
import {QCardSection,QForm,QScrollArea,QInput,QSelect,QIcon,QPopupProxy,QDate,QBtn,QTime,QExpansionItem,ClosePopup} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCardSection,QForm,QScrollArea,QInput,QSelect,QIcon,QPopupProxy,QDate,QBtn,QTime,QExpansionItem})
component.options.directives = Object.assign(Object.create(component.options.directives || null), component.options.directives || {}, {ClosePopup})
